import { FigureSettings, isFigureSettings } from "aic";
import axios from "axios";
import { IAxiosReturn, ISetting } from "../interface";
import { processAxiosError } from "../processAxiosError";

export type IFigureTypeOptionsReturn = IAxiosReturn<FigureSettings>;

/**
 * Load available figure type options from settings.
 *
 * @param backEndUrl - Base backend URL
 * @returns List of figure type option descriptors wrapped in IFigureTypeOptionsReturn
 */
export const getFigureTypeOptions = async (
  backEndUrl: string,
): Promise<IFigureTypeOptionsReturn> => {
  const url = `${backEndUrl}Settings/figureTypeOptions`;
  // Get data
  try {
    const response: { data: ISetting } = await axios.get(url);
    const returnedObject = JSON.parse(response.data.value);
    // Validate returned data
    if (!isFigureSettings(returnedObject)) {
      console.error("getFigureTypeOptions: returnedObject failed isFigureSettings check");
      return {
        success: false,
        errorText: "Load figure type options failed: invalid data format",
      };
    }
    const returnedFigureSettings: FigureSettings = returnedObject;

    // Return successful result
    return {
      success: true,
      data: returnedFigureSettings,
    };
  } catch (error: unknown) {
    console.debug("getFigureTypeOptions: caught error", error);
    return processAxiosError("Load figure type options failed", error);
  }
};
